// French translations (Français)
import type { TranslationKeys } from './en';

export const fr: TranslationKeys = {
  // Common
  common: {
    home: 'Accueil',
    settings: 'Paramètres',
    language: 'Langue',
    loading: 'Chargement...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    close: 'Fermer',
    back: '← Retour',
    continue: 'Continuer',
    accept: 'Accepter',
    decline: 'Refuser',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'Nouvelle-Zélande',
  },

  // Settings Menu
  settings: {
    header: 'Paramètres',
    home: 'Accueil',
    howToPlay: 'Comment Jouer',
    pieceRules: 'Règles des Pièces',
    language: 'Langue',
    manageSubscription: 'Gérer l\'Abonnement',
    gameHistory: 'Historique des Parties',
    analytics: 'Analytique',
    premiumAccount: 'Compte Premium',
    chatEnabled: 'Chat: Activé',
    chatDisabled: 'Chat: Désactivé',
  },

  // Piece Rules
  pieceRules: {
    title: 'Règles des Pièces',
    description: 'Apprenez le mouvement des pièces',
    selectPiece: 'Sélectionner une Pièce',
    selectedLabel: 'Sélectionné:',
    statusLabel: 'Statut:',
    statusReady: 'Prêt',
    statusViewing: 'Visualisation',
    movement: 'Mouvement',
    regularMovement: 'Mouvement Régulier',
    ability: 'Capacité',
    backToSelection: 'Retour à la sélection',
    backToHome: 'Retour à l\'accueil',
  },

  // Move/Ability Names
  moves: {
    movement: 'Mouvement',
    savage: 'Sauvage',
    birdtype: 'Type Oiseau',
    birdType: 'Type Oiseau',
    wallBlock: 'Bloc de Mur',
    moveblocks: 'Blocs de Mouvement',
    wallclimb: 'Escalade de Mur',
    lilypad: 'Nénuphar',
    poisonous: 'Venimeux',
    meadow: 'Prairie',
    parasiticfungi: 'Champignon Parasite',
    zombification: 'Zombification',
    fungi: 'Champignon',
    traverse: 'Traverser',
    capture: 'Capturer',
    faint: 'Évanouir',
    leap: 'Bond',
    swing: 'Balancer',
    consume: 'Consommer',
    gamble: 'Parier',
    entangle: 'Enchevêtrer',
    ink: 'Encre',
    rotate: 'Pivoter',
    backstep: 'Pas Arrière',
    trample: 'Piétiner',
    charge: 'Charge',
    lane: 'Voie',
    snakestrike: 'Frappe de Serpent',
    shedskin: 'Mue',
    house: 'Maison',
    plant: 'Type Plante',
    planttype: 'Type Plante',
    capturehost: 'Capturer l\'Hôte',
    contagion: 'Contagion',
    lonewolf: 'Loup Solitaire',
    hop: 'Saut',
    decay: 'Décomposition',
    slide: 'Glisser',
    block: 'Bloquer',
    poison: 'Poison',
    infection: 'Infection',
    howl: 'Hurlement',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'L\'Ours peut se déplacer d\'une case dans n\'importe quelle direction, comme un roi aux échecs',
    bearMovementPost: 'Il n\'est bloqué que par les pièces amies (sauf les Arbres, les Ours peuvent grimper aux Arbres !)',
    bearSavage: 'Un Ours peut surmonter les capacités défensives comme le Bloc du Rhinocéros',
    bearSavagePost: 'En utilisant Sauvage, l\'Ours peut capturer n\'importe quelle pièce de n\'importe quelle direction, ajoutant de la létalité',

    // Crane
    craneMovement: 'La Grue peut se déplacer de 1 ou 2 cases en ligne droite',
    craneMovementPost: 'La Grue peut même voler par-dessus d\'autres pièces !',
    craneBirdType: 'Les pièces de type oiseau ne peuvent pas capturer les grandes pièces ou les prédateurs',
    craneBirdTypePost: 'Cela inclut l\'Arbre, le Rhinocéros, l\'Ours et le Loup',

    // Frog
    frogMovement: 'La Grenouille bondit de 2 cases en diagonale',
    frogMovementPost: 'Elle ne peut pas sauter d\'une seule case',
    frogWallBlock: 'Si le chemin régulier de 2 cases de la Grenouille est bloqué par un mur ou une autre pièce, elle ne peut pas capturer',
    frogWallBlockPost: 'Son mouvement régulier est réduit à 1 case en diagonale',
    frogWallClimb: 'Lorsque la Grenouille est sur le mur du plateau (Colonne A ou E), elle peut se déplacer d\'une case vers le haut ou le bas',
    frogWallClimbPost: 'Sauf si elle est bloquée par une pièce amie ou un Rhinocéros devant la Grenouille',
    frogLilypad: 'Si la Grenouille n\'a pas encore bougé dans une partie, elle peut se déplacer sur l\'une des 3 premières rangées comme une puissante capacité défensive',
    frogLilypadPost: 'Elle peut capturer n\'importe quelle pièce régulière en utilisant le Saut de Nénuphar, sauf un Rhinocéros sur une rangée supérieure',
    frogPoisonous: 'Lorsqu\'un animal capture une pièce Grenouille, vous devenez empoisonné !',
    frogPoisonousPost: 'Une pièce empoisonnée saute son prochain tour disponible avant de récupérer',

    // Fungi
    fungiMovement: 'Le Champignon peut se déplacer d\'une case dans n\'importe quelle direction',
    fungiMovementPost: 'Il n\'est bloqué que par les pièces alliées',
    fungiMeadow: 'Le Champignon réduit la capacité de mouvement de la pièce Arbre ennemie',
    fungiMeadowPost: 'La pièce Arbre ennemie ne peut pas se déplacer à 1 case du Champignon',
    fungiParasitic: 'Le Champignon peut immobiliser la pièce Arbre ennemie',
    fungiParasiticPost: 'Si le Champignon est à 1 case de l\'Arbre ennemi, il ne peut pas bouger jusqu\'à ce que le Champignon s\'éloigne ou soit capturé',
    fungiZombification: 'Le Champignon peut zombifier n\'importe quelle pièce animale ennemie qui le capture, permettant de contrôler l\'animal ennemi pendant un tour',
    fungiZombificationPost: 'La pièce zombifiée est également considérée comme la pièce Champignon pour ce tour, même si le Champignon était votre roi, le jeu ne se termine pas avant la fin de ce tour',
    fungiFungi: 'Le Champignon est un champignon, pas un animal, il est donc immunisé contre plusieurs effets',
    fungiFungiPost: 'Comme le poison, l\'enchevêtrement et l\'infection virale, mais pas la zombification car il peut zombifier les autres !',

    // Goat
    goatMovement: 'La Chèvre peut se déplacer d\'une case dans n\'importe quelle direction',
    goatMovementPost: 'La Chèvre se déplace lentement mais possède de puissantes capacités',
    goatTraverse: 'La Chèvre peut traverser n\'importe quelles autres pièces connectées pour créer un potentiel de mouvement massif',
    goatTraversePost: 'La Chèvre ne peut pas traverser les Chèvres Évanouies ou les pièces Minuscules comme le Virus',
    goatCapture: 'La Chèvre ne peut capturer aucun Prédateur',
    goatCapturePost: 'Comme l\'Ours ou le Loup',
    goatFaint: 'La Chèvre peut s\'évanouir pour éviter la capture sauf par les grandes pièces comme l\'Arbre et le Rhinocéros',
    goatFaintPost: 'En étant évanouie, les adversaires peuvent "se tenir" sur la chèvre évanouie pour arrêter son mouvement',

    // Monkey
    monkeyMovement: 'Le Singe peut se déplacer d\'une case dans n\'importe quelle direction',
    monkeyMovementPost: 'Sans autres pièces à utiliser, le Singe a un mouvement limité',
    monkeyLeap: 'Le Singe, comme un jeu de dames, peut bondir par-dessus d\'autres pièces en ligne droite pour un énorme potentiel de mouvement',
    monkeyLeapPost: 'Mais s\'il bondit par-dessus une pièce ennemie, le Singe doit lancer un dé pour survivre au saut, 1/6 de chance de capture pour chaque ennemi qu\'il saute !',
    monkeySwing: 'Si un Singe utilise un bond par-dessus un Arbre, le Singe gagne un tour bonus',
    monkeySwingPost: 'L\'utilisation de la balançoire d\'arbre crée un combo synergique puissant entre les pièces Singe et Arbre',
    monkeyConsume: 'Le Singe peut consommer une pièce Champignon pour un tour bonus',
    monkeyConsumePost: 'Conduisant à des combinaisons dévastatrices lorsqu\'elles sont combinées avec d\'autres tours bonus',
    monkeyGamble: 'En plus de lancer un dé pour bondir par-dessus les ennemis, le Singe doit parier pour capturer l\'Ours',
    monkeyGamblePost: 'Le singe doit obtenir un 5 ou un 6 sur un dé à 6 faces pour capturer l\'Ours ou il est lui-même capturé',

    // Octopus
    octopusMovement: 'La Pieuvre se déplace d\'une case dans n\'importe quelle direction',
    octopusCapture: 'La Pieuvre ne peut capturer qu\'orthogonalement',
    octopusCapturePost: 'La pieuvre peut capturer ou enchevêtrer les pièces de manière complexe, vérifiez toujours les captures rouges et les enchevêtrements violets !',
    octopusEntangle: 'La Pieuvre peut enchevêtrer les pièces ennemies adjacentes, les immobilisant, elle peut même se déplacer d\'une case et enchevêtrer les ennemis !',
    octopusEntanglePost: 'Les pièces enchevêtrées ne peuvent pas bouger jusqu\'à ce que la Pieuvre s\'éloigne ou soit capturée',
    octopusInk: 'La Pieuvre peut utiliser l\'encre pour échapper aux situations dangereuses, créant jusqu\'à 3 ombres',
    octopusInkPost: 'Confondant l\'ennemi et permettant des jeux d\'appât et d\'évasion intéressants',

    // Penguin
    penguinMovement: 'Le Pingouin glisse en ligne droite dans sa direction fixée jusqu\'à ce qu\'un mur ou une pièce bloque son mouvement',
    penguinMovementPost: 'Après s\'être déplacé, le Pingouin dans le même tour peut définir sa direction finale également',
    penguinRotate: 'Au début du match, un Pingouin fait face vers le bas et doit pivoter avant de pouvoir glisser, également connu comme dormant',
    penguinRotatePost: 'Le pingouin dans n\'importe quelle position peut choisir de pivoter au lieu de se déplacer',
    penguinBirdType: 'Le Pingouin a des capacités de capture limitées, comme la Grue, il ne peut pas capturer les grandes pièces ou les prédateurs comme l\'Arbre, le Rhinocéros, l\'Ours ou le Loup',
    penguinBirdTypePost: 'Après avoir capturé, le Pingouin peut pivoter dans n\'importe quelle direction pour un positionnement stratégique',

    // Rhino
    rhinoMovement: 'Le Rhinocéros se déplace de deux cases vers l\'avant seulement',
    rhinoMovementPost: 'Il ne peut pas se déplacer d\'une seule case',
    rhinoBackStep: 'Le Rhinocéros peut se déplacer en arrière-gauche ou arrière-droite',
    rhinoCharge: 'Le Rhinocéros une fois par partie peut parcourir une case supplémentaire vers l\'avant en utilisant sa capacité de charge',
    rhinoChargePost: 'Conduisant à un potentiel de mouvement et de capture dévastateur',
    rhinoTrample: 'Le Rhinocéros capture toutes les pièces sur son chemin avec Piétiner',
    rhinoTramplePost: 'Y compris une pièce Chèvre évanouie',
    rhinoLane: 'Le Rhinocéros peut échanger sa place avec une autre pièce alliée permettant un jeu de voie stratégique',
    rhinoLanePost: 'Mais seulement si le Rhinocéros et la pièce Alliée n\'ont pas encore bougé',

    // Snake
    snakeMovement: 'Le Serpent peut se déplacer de 2 cases en ligne droite',
    snakeMovementPost: 'Le Serpent se déplace exactement de 2 cases sauf s\'il est bloqué par un mur ou une pièce amie',
    snakeMoveBlocks: 'Lorsqu\'il est bloqué par un mur ou une pièce qu\'il ne peut pas capturer, le mouvement du Serpent est réduit à 1 case',
    snakeMoveBlocksPost: 'Il peut toujours se déplacer de deux cases même s\'il y a une pièce intermédiaire',
    snakeStrike: 'Le Serpent peut frapper 3 cases vers l\'avant s\'il y a un animal ennemi',
    snakeStrikePost: 'Tant qu\'aucune pièce intermédiaire ne bloque son chemin',
    snakeShedskin: 'Une fois par partie, le Serpent peut muer et retourner à la première rangée si la case est libre',
    snakeShedskinPost: 'Cette renaissance donne au Serpent une vie supplémentaire à chaque partie',

    // Tree
    treeMovement: 'L\'Arbre peut se déplacer d\'une case vers l\'avant ou vers n\'importe quelle case sur sa rangée de côté',
    treeMovementPost: 'Tant que son chemin n\'est pas bloqué',
    treeHouse: 'L\'Arbre peut héberger d\'autres pièces, les protégeant des ennemis qui ne peuvent pas grimper aux Arbres. Peut-être que les pièces peuvent grimper comme l\'Ours, la Grue, la Grenouille, le Champignon, la Chèvre, le Singe, la Pieuvre et le Serpent',
    treeHousePost: 'Lorsqu\'une pièce qui peut grimper à un arbre attaque, elle ne capture que la pièce hébergée, protégeant l\'Arbre',
    treeTrample: 'L\'Arbre comme le Rhinocéros, capture toutes les pièces sur une case lorsqu\'il se déplace',
    treeTramplePost: 'Cela inclut une Chèvre évanouie',
    treePlant: 'L\'Arbre est une plante, pas un animal, il est donc immunisé contre plusieurs effets',
    treePlantPost: 'Comme le poison, la zombification, l\'enchevêtrement et l\'infection virale !',

    // Virus
    virusMovement: 'Le Virus ne peut se déplacer que vers des cases occupées par des animaux, qui sont à deux cases de distance',
    virusMoveBlocks: 'Le Virus ne peut se déplacer que d\'une case s\'il est à côté d\'un mur',
    virusCaptureHost: 'Lorsque le Virus atterrit sur (dans) n\'importe quelle pièce animale, il ne fait que les infecter, ils peuvent toujours continuer à jouer normalement en étant infectés',
    virusCaptureHostPost: 'Le Virus ne capture la pièce que lorsqu\'il quitte l\'hôte infecté',
    virusContagion: 'Le Virus peut se propager rapidement en infectant plusieurs hôtes en un seul tour',
    virusContagionPost: 'La contagion permet au Virus de faire autant de mouvements légaux qu\'il le souhaite à chaque tour',

    // Wolf
    wolfMovement: 'Le Loup peut se déplacer en forme de L, comme le cavalier aux échecs',
    wolfMovementPost: 'Il n\'est pas obstrué par d\'autres pièces',
    wolfLoneWolf: 'Lorsque le Loup n\'a plus d\'alliés, son schéma de mouvement passe à un L allongé se déplaçant d\'une case supplémentaire',
    wolfLoneWolfPost: 'Le Loup se considère également solitaire lorsqu\'il a encore une Chèvre évanouie ou un allié virus',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 Glissez pour explorer • Pincez pour zoomer',
    dragToExploreDesktop: '🖱️ Glissez pour explorer • Défilez pour zoomer',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    failed: 'ÉCHEC !',
    success: 'SUCCÈS !',
    failedDefaultMessage: 'N\'abandonnez pas ! Essayez une approche différente.',
    superMessage: 'Parfait ! Vous avez obtenu une complétion Super !',
    passMessage: 'Bien joué ! Tutoriel terminé !',
    tryAgain: 'Réessayer',
    back: 'Retour',
    next: 'Suivant',
    backToDev: 'Retour au Dev',
    backToTutorials: 'Retour aux Tutoriels',
    continue: 'Continuer',
    close: 'Fermer',
  },

  // Sandbox
  sandbox: {
    title: 'BAC À SABLE',
    description: 'Expérimentez et Pratiquez',
    mode: 'Mode:',
    modeValue: 'Bac à sable',
    status: 'Statut:',
    statusReady: 'Prêt',
    clearBoard: 'Effacer le Plateau',
  },

  // Multiplayer
  multiplayer: {
    title: 'MULTIJOUEUR',
    description: 'Trouvez votre match et affrontez-vous !',

    // Placement matches
    placementMatches: 'Matchs de Placement',
    matchProgress: 'Progression du Match',
    gamesCompleted: '{games} / 10 Parties Terminées',
    estimatedFinalRating: 'Classement Final Estimé',
    startingRating: 'Classement de départ',
    matchesRemaining: '{matches} matchs restants',
    findPlacementMatch: 'Trouver un Match de Placement',

    // Matchmaking modes
    findMatch: 'Trouver un Match',
    competitive: 'Compétitif',
    competitiveDesc: 'Trouvez des adversaires proches de votre classement',
    quick: 'Rapide',
    quickDesc: 'Trouvez des matchs compétitifs rapidement',
    casual: 'Décontracté',
    casualDesc: 'Non classé - jouez pour le plaisir !',
    placement: 'Placement',
    placementDesc: 'Complétez 10 matchs pour être classé',
    startSearch: 'Démarrer la Recherche',

    // Searching
    searching: 'Recherche...',
    mode: 'Mode:',
    inQueue: 'Dans la File:',
    players: 'joueur',
    playersPlural: 'joueurs',
    cancelSearch: 'Annuler la Recherche',

    // Game info
    status: 'Statut:',
    ready: 'Prêt',
    selectingKing: 'Sélection du Roi',
    placingPieces: 'Placement des Pièces',
    playing: 'En Jeu',
    gameType: 'Type de Jeu:',
    opponent: 'Adversaire:',
    opponentElo: 'ELO de l\'Adversaire:',
    unranked: 'Non Classé',

    // Piece placement
    dragPieces: 'Glissez les pièces sur le plateau',
    lightPieces: 'Pièces Claires (Vous)',
    darkPieces: 'Pièces Sombres (Vous)',

    // Waiting states
    waitingForOpponent: 'En Attente de l\'Adversaire...',
    waitingForKing: 'En attente que l\'adversaire sélectionne son roi...',

    // Warnings
    invalidPlacement: 'Placement Invalide',
    lightTurn: 'C\'est le tour du joueur Clair !',
    darkTurn: 'C\'est le tour du joueur Sombre !',
    onlyLightPieces: 'Vous ne pouvez placer que des pièces claires !',
    onlyDarkPieces: 'Vous ne pouvez placer que des pièces sombres !',
    mustPlaceOnRow: 'Les pièces {color} doivent être placées sur la rangée {row} !',

    // Chat
    chat: 'Chat',
    typeMessage: 'Tapez un message...',
    send: 'Envoyer',
    rematchRequest: 'Demande de Revanche',
    rematchMessage: '{opponentUsername} veut rejouer !',
  },

  // Main Page
  mainPage: {
    title: 'ÉCHECS ANIMAUX',
    subtitle: 'Un jeu pour les humains',
    playersOnline: 'Joueurs actuellement en ligne',
    placement: 'Placement',
    placementProgress: 'Placement',
    challengeAI: 'Défier l\'IA',
    multiplayer: 'Multijoueur',
    sandbox: 'Bac à sable',
    tutorials: 'Tutoriels',
    shop: 'Boutique',
    collection: 'Collection',
    history: 'Historique',
    analytics: 'Analytique',
    courses: 'Cours',
    upgradeAccount: 'Améliorer le compte',
    signIn: 'Se Connecter',
    playAsGuest: 'Jouer en Invité',
    welcomeBack: 'Bon retour ! Vous jouez habituellement en tant que',

    // Learn the Pieces section
    learnThePieces: 'Apprenez les pièces',

    // Learn the Rules section
    learnTheRules: 'Apprenez les Règles',
    premiseTitle: 'Prémisse',
    premiseText: 'Zodiac est une alternative aux échecs avec un roi CACHÉ parmi une liste de 13 pièces, sélectionnez une liste unique puis bluffez votre adversaire pour le vaincre sur un plateau 5 par 8',
    selectionTitle: 'Sélection',
    selectionText: 'Pour commencer une partie, choisissez secrètement votre roi, puis placez vos 5 pièces alternativement avec votre adversaire pour créer l\'un des plus de 500 milliards d\'états initiaux.',
    objectiveTitle: 'Objectif',
    objectiveText: 'Soit lisez votre adversaire pour CAPTURER son roi secret, soit FAITES COURIR votre roi à travers le plateau pour assurer la victoire !',
    competeTitle: 'Affrontez-vous',
    competeText: 'Testez vos compétences sur l\'échelle, développez de nouvelles techniques et stratégies personnelles, montez en rang pour affronter les meilleurs !',
    fullRulesButton: 'Pour les règles officielles complètes, cliquez ici',

    // FAQ section
    faqTitle: 'Questions Fréquemment Posées',
    faqQuestion1: 'Quelle est l\'idée derrière les échecs Zodiac ?',
    faqAnswer1: 'Les échecs Zodiac ont été initialement inspirés par les paroles de Bobby Fischer sur son inspiration pour créer les Chess960, nous voulions développer l\'idée de combattre la mémorisation par cœur et célébrer l\'intuition humaine dans une profondeur insondable !',
    faqQuestion2: 'Pourquoi avons-nous besoin d\'une alternative aux échecs',
    faqAnswer2: 'Nous n\'en avons pas besoin ! Zodiac ne veut pas détourner les gens de jouer aux échecs ! C\'est une option différente avec ses propres forces et faiblesses, nous espérons que vous vous amuserez avec et nous aiderez à adapter ce jeu pour animer de nouvelles parties',
    faqQuestion3: 'Comment gagne-t-on aux Échecs Zodiac ?',
    faqAnswer3: 'Il y a trois façons de gagner : capturer la pièce roi cachée de votre adversaire, faire courir votre propre roi de l\'autre côté du plateau, ou dans un match avec contrôle du temps, que le temps de votre adversaire s\'épuise',
    faqQuestion4: 'Est-ce une FAQ ?',
    faqAnswer4: 'Oui, vous pouvez consulter n\'importe laquelle des questions listées dans la FAQ et si vous voulez plus de détails, vous pouvez cliquer sur les questions puis lire les détails suivants, comme ces détails que vous lisez maintenant',
    faqQuestion5: 'Combien de temps dure une partie typique ?',
    faqAnswer5: 'Chaque partie diffère grandement ! Certaines parties se terminent en 2 coups et certaines peuvent prendre 30 minutes, nous avons tendance à les trouver dans la fourchette de 5-15 minutes !',
    faqQuestion6: 'Que se passe-t-il si personne ne peut faire un coup légal ?',
    faqAnswer6: 'Si un joueur ne peut faire aucun coup légal (pat), la partie se termine par un match nul. La partie peut également se terminer par un match nul par répétition (même état du plateau 3 fois) ou par accord mutuel entre les joueurs !',

    // About section
    aboutButton: 'À propos',
    privacyPolicy: 'Politique de Confidentialité',
    developerInterface: 'Interface Développeur',
  },

  // About Modal
  about: {
    title: 'À propos de Zodiac',
    paragraph1: 'Zodiac est un jeu de plateau similaire aux échecs combinant des éléments de sélection de pièces de jeux comme LoL et DotA, avec des mécaniques de bluff du poker ou des jeux de déduction sociale.',
    paragraph2: 'Les premières versions du jeu ont été créées en 2014, sous le nom Shadow Chess. En 2018, il a été redessiné pour devenir ce que vous voyez aujourd\'hui, impliquant une liste de pièces amusantes avec des schémas de mouvement et des capacités équilibrés mais uniques.',
    paragraph3: 'Notre vision est d\'enregistrer toutes les données de jeu des utilisateurs pour continuer à faire évoluer le jeu dans un effort pour garder le gameplay rafraîchissant, encourageant les nouvelles parties.',
    paragraph4: 'Avec l\'espace de recherche géant de Zodiac, les informations cachées et les positions d\'ouverture du plateau, nous espérons éviter la domination de l\'IA et garder zodiac un jeu pour les humains !',
  },

  // Privacy Policy
  privacy: {
    title: 'Politique de Confidentialité',
    lastUpdated: 'Dernière Mise à Jour',

    introduction: {
      title: 'Introduction',
      p1: 'Bienvenue sur Zodiac Chess ("nous", "notre" ou "nos"). Nous nous engageons à protéger votre vie privée et à vous garantir une expérience de jeu sûre et agréable. Cette Politique de Confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous utilisez notre site Web et notre jeu.',
      p2: 'En utilisant Zodiac Chess, vous acceptez la collecte et l\'utilisation des informations conformément à cette politique. Si vous n\'acceptez pas nos politiques et pratiques, veuillez ne pas utiliser notre service.',
      contact: 'Contactez-nous à :',
    },

    infoCollect: {
      title: 'Informations que Nous Collectons',
      accountInfo: {
        title: '1. Informations de Compte',
        item1: 'Adresse E-mail : Requise pour la création de compte et la communication',
        item2: 'Nom d\'Utilisateur : Votre nom d\'affichage choisi',
        item3: 'Mot de Passe : Crypté et stocké en toute sécurité',
      },
      gameData: {
        title: '2. Données de Jeu',
        item1: 'Statistiques de Jeu : Victoires, défaites, classement ELO, progression des matchs de placement',
        item2: 'Données de Gameplay : Sélections de pièces, coups effectués, stratégies utilisées',
        item3: 'Historique des Matchs : Enregistrements des parties jouées, adversaires rencontrés',
        item4: 'Achats Dans le Jeu : Articles cosmétiques et statut d\'abonnement premium',
      },
      technicalData: {
        title: '3. Données Techniques',
        item1: 'Informations sur l\'Appareil : Type de navigateur, système d\'exploitation',
        item2: 'Données d\'Utilisation : Pages visitées, temps passé, fonctionnalités utilisées',
        item3: 'Stockage Local : Préférences linguistiques, paramètres d\'interface utilisateur, état temporaire du jeu',
      },
    },

    children: {
      title: 'Confidentialité des Enfants (Conformité COPPA)',
      p1: 'Zodiac Chess est conçu pour être familial et adapté aux joueurs de tous âges, y compris les enfants. Nous prenons un soin particulier pour nous conformer à la Loi sur la Protection de la Vie Privée des Enfants en Ligne (COPPA).',
      p2: 'Pour les utilisateurs de moins de 13 ans : Nous recommandons aux enfants d\'utiliser notre mode de jeu invité, qui ne nécessite pas de création de compte ni de collecte de données. Les comptes invités n\'ont pas accès aux fonctionnalités de chat textuel, garantissant que les enfants ne sont pas exposés à la communication avec l\'internet au sens large. Si un enfant crée un compte, nous exigeons le consentement parental avant de collecter des informations personnelles.',
      p3: 'Nous NE collectons PAS, n\'utilisons PAS ou ne partageons PAS sciemment d\'informations personnelles d\'enfants de moins de 13 ans sans le consentement parental vérifié.',
      p4: 'Sécurité du Chat : Le chat textuel est automatiquement désactivé pour tous les comptes invités/temporaires. Les titulaires de comptes standard ont la possibilité de désactiver la fonctionnalité de chat dans les paramètres de leur compte à tout moment.',
      parentalRights: 'Les parents ont le droit de :',
      right1: 'Consulter les informations personnelles de leur enfant',
      right2: 'Demander la suppression des données de leur enfant',
      right3: 'Refuser la collecte ou l\'utilisation ultérieure des informations de leur enfant',
      contactUs: 'Pour exercer ces droits ou si vous pensez que votre enfant nous a fourni des informations personnelles, veuillez nous contacter immédiatement à contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'Comment Nous Utilisons Vos Informations',
      item1: 'Fournir et améliorer nos services de jeu',
      item2: 'Vous associer à des adversaires appropriés en fonction du niveau de compétence',
      item3: 'Suivre votre progression, vos statistiques et vos réalisations',
      item4: 'Traiter les paiements pour les abonnements premium et les articles cosmétiques',
      item5: 'Envoyer des annonces de service importantes et des mises à jour',
      item6: 'Analyser les données de jeu pour améliorer l\'équilibre du jeu et les fonctionnalités',
    },

    thirdParty: {
      title: 'Services Tiers',
      firebase: {
        title: 'Firebase (Google)',
        description: 'Nous utilisons Firebase pour l\'authentification, le stockage de base de données et la fonctionnalité multijoueur. Firebase peut collecter certaines données comme décrit dans leur politique de confidentialité.',
      },
      stripe: {
        title: 'Stripe',
        description: 'Nous utilisons Stripe pour traiter les paiements pour les abonnements premium et les achats dans l\'application. Stripe gère toutes les informations de carte de paiement - nous ne voyons ni ne stockons jamais vos détails de paiement complets.',
      },
      netlify: {
        title: 'Netlify',
        description: 'Notre site Web est hébergé sur Netlify, qui peut collecter des données d\'hébergement Web standard telles que les adresses IP et les journaux d\'accès.',
      },
      adsense: {
        title: 'Google AdSense (Futur)',
        description: 'Nous pouvons afficher des publicités via Google AdSense. Ces publicités peuvent utiliser des cookies pour la personnalisation. Pour le contenu destiné aux enfants, nous n\'afficherons que des publicités non personnalisées conformément à la COPPA.',
      },
      viewPolicy: 'Voir leur Politique de Confidentialité',
    },

    cookies: {
      title: 'Cookies et Stockage Local',
      description: 'Nous utilisons le stockage local du navigateur (similaire aux cookies) pour améliorer votre expérience :',
      item1: 'Préférence Linguistique : Mémoriser votre langue sélectionnée',
      item2: 'Session de Compte : Vous garder connecté (fonctionne avec Firebase)',
      item3: 'Paramètres de Jeu : Mémoriser vos préférences d\'interface utilisateur et les configurations de bac à sable',
      item4: 'Cookies Publicitaires : Si vous y consentez, les services publicitaires tiers peuvent utiliser des cookies pour la personnalisation des publicités',
    },

    security: {
      title: 'Sécurité des Données',
      p1: 'Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos informations :',
      item1: 'Cryptage des Mots de Passe : Tous les mots de passe sont cryptés en utilisant des méthodes standard de l\'industrie',
      item2: 'Connexions Sécurisées : Cryptage HTTPS pour toute transmission de données',
      item3: 'Règles de Sécurité Firebase : Contrôles d\'accès stricts à la base de données',
      p2: 'Cependant, aucune méthode de transmission sur Internet n\'est sûre à 100%. Bien que nous nous efforcions de protéger vos données, nous ne pouvons pas garantir une sécurité absolue.',
    },

    retention: {
      title: 'Conservation des Données',
      p1: 'Nous conservons vos données comme suit :',
      item1: 'Comptes Actifs : Les données sont conservées tant que votre compte est actif',
      item2: 'Comptes Inactifs : Si votre compte est inactif pendant 10 ans, nous pouvons supprimer vos données',
    },

    rights: {
      title: 'Vos Droits à la Vie Privée',
      description: 'Selon votre emplacement, vous pouvez avoir les droits suivants :',
      access: {
        title: 'Accès :',
        description: 'Demander une copie de vos données personnelles',
      },
      correction: {
        title: 'Correction :',
        description: 'Demander des corrections à vos données',
      },
      deletion: {
        title: 'Suppression :',
        description: 'Demander la suppression de votre compte et de vos données',
      },
      portability: {
        title: 'Portabilité des Données :',
        description: 'Demander vos données dans un format portable',
      },
      optOut: {
        title: 'Désabonnement :',
        description: 'Se désabonner des communications marketing',
      },
      contact: 'Pour exercer l\'un de ces droits, veuillez nous contacter à contact@zodiac-chess.com',
    },

    international: {
      title: 'Utilisateurs Internationaux',
      p1: 'Zodiac Chess est exploité depuis la Nouvelle-Zélande. Si vous accédez à notre service depuis l\'extérieur de la Nouvelle-Zélande, veuillez noter que vos informations peuvent être transférées, stockées et traitées en Nouvelle-Zélande et dans d\'autres pays où nos prestataires de services opèrent.',
      p2: 'En utilisant notre service, vous consentez au transfert de vos informations vers des pays en dehors de votre pays de résidence, qui peuvent avoir des lois de protection des données différentes.',
    },

    changes: {
      title: 'Modifications de Cette Politique de Confidentialité',
      description: 'Nous pouvons mettre à jour cette Politique de Confidentialité de temps en temps. Nous vous informerons de tout changement en publiant la nouvelle Politique de Confidentialité sur cette page et en mettant à jour la date de "Dernière Mise à Jour". Les changements importants seront communiqués par e-mail ou par un avis bien visible sur notre site Web.',
    },

    contact: {
      title: 'Nous Contacter',
      description: 'Si vous avez des questions, des préoccupations ou des demandes concernant cette Politique de Confidentialité ou nos pratiques en matière de données, veuillez nous contacter :',
      email: 'E-mail :',
      company: 'Entreprise :',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Conditions d\'Utilisation',
    lastUpdated: 'Dernière mise à jour',
    back: 'Retour',
    viewPrivacyPolicy: 'Voir la Politique de Confidentialité',
    acknowledgment: 'En utilisant Zodiac Chess, vous reconnaissez avoir lu, compris et accepté d\'être lié par ces Conditions d\'Utilisation.',
    acceptance: {
      title: '1. Acceptation des Conditions',
      p1: 'En accédant et en utilisant Zodiac Chess (le « Service »), vous acceptez et convenez d\'être lié par ces Conditions d\'Utilisation. Si vous n\'acceptez pas ces conditions, veuillez ne pas utiliser le Service.',
      p2: 'Nous nous réservons le droit de modifier ces conditions à tout moment. L\'utilisation continue du Service après les modifications constitue l\'acceptation des conditions modifiées.',
    },
    description: {
      title: '2. Description du Service',
      p1: 'Zodiac Chess est un jeu de plateau stratégique en ligne avec des pièces animales uniques dotées de capacités spéciales. Le Service comprend :',
      feature1: 'Jeu solo contre des adversaires IA',
      feature2: 'Matchmaking multijoueur et jeu compétitif',
      feature3: 'Tutoriels interactifs et ressources d\'apprentissage',
      feature4: 'Création de compte et suivi de progression',
      feature5: 'Fonctionnalités d\'abonnement premium optionnelles',
      feature6: 'Options de personnalisation cosmétique',
    },
    accounts: {
      title: '3. Comptes Utilisateurs',
      eligibility: {
        title: '3.1 Éligibilité',
        p1: 'Vous devez avoir au moins 13 ans pour créer un compte. Les utilisateurs de moins de 13 ans peuvent utiliser le mode invité sous surveillance parentale mais ne peuvent pas créer de comptes.',
      },
      responsibilities: {
        title: '3.2 Sécurité du Compte',
        p1: 'Vous êtes responsable de :',
        item1: 'Maintenir la confidentialité de votre mot de passe',
        item2: 'Toutes les activités qui se produisent sous votre compte',
        item3: 'Nous notifier immédiatement de toute utilisation non autorisée',
        p2: 'Nous ne sommes pas responsables des pertes ou dommages résultant d\'un accès non autorisé au compte.',
      },
      prohibited: {
        title: '3.3 Activités Interdites',
        p1: 'Vous ne pouvez PAS :',
        item1: 'Partager votre compte avec d\'autres personnes',
        item2: 'Utiliser plusieurs comptes pour manipuler les classements',
        item3: 'Utiliser des bots, scripts ou outils automatisés pour jouer',
        item4: 'Harceler, abuser ou menacer d\'autres joueurs',
        item5: 'Exploiter des bugs ou des failles pour un avantage déloyal',
        item6: 'Faire de l\'ingénierie inverse ou tenter d\'accéder à notre code source',
        p2: 'La violation de ces règles peut entraîner la suspension du compte ou un bannissement permanent.',
      },
    },
    premium: {
      title: '4. Abonnements Premium',
      billing: {
        title: '4.1 Facturation',
        p1: 'Les abonnements premium sont traités via Stripe. En achetant un abonnement premium, vous nous autorisez à débiter votre moyen de paiement de manière récurrente jusqu\'à annulation.',
        p2: 'Les frais d\'abonnement sont :',
        item1: 'Plan Mensuel : Facturé mensuellement à la date anniversaire de votre achat',
        item2: 'Plan Annuel : Facturé annuellement à la date anniversaire de votre achat',
        p3: 'Les prix sont susceptibles de changer avec un préavis de 30 jours aux abonnés actifs.',
      },
      cancellation: {
        title: '4.2 Annulation',
        p1: 'Vous pouvez annuler votre abonnement à tout moment via les paramètres de votre compte ou en contactant le support. L\'annulation prend effet à la fin de votre période de facturation actuelle.',
        p2: 'Vous conserverez les fonctionnalités premium jusqu\'à la fin de votre période payée, même après annulation.',
      },
      refunds: {
        title: '4.3 Remboursements',
        p1: 'Abonnements mensuels : Pas de remboursement pour les mois partiels. Annulez à tout moment pour arrêter les frais futurs.',
        p2: 'Abonnements annuels : Remboursement complet si demandé dans les 7 jours suivant l\'achat. Après 7 jours, les remboursements sont à notre discrétion.',
        p3: 'Achats cosmétiques : Généralement non remboursables. Contactez le support pour des circonstances exceptionnelles.',
      },
    },
    acceptable: {
      title: '5. Politique d\'Utilisation Acceptable',
      p1: 'Vous acceptez d\'utiliser Zodiac Chess de manière respectueuse et légale. Les comportements interdits comprennent :',
      item1: 'Tricher, pirater ou exploiter les mécaniques du jeu',
      item2: 'Harcèlement, discours haineux ou langage discriminatoire',
      item3: 'Spam, publicité ou sollicitation',
      item4: 'Partage de contenu inapproprié (si le chat ou le contenu généré par l\'utilisateur est activé)',
      item5: 'Se faire passer pour d\'autres utilisateurs ou membres du personnel',
      item6: 'Tenter de perturber ou d\'endommager le Service',
      p2: 'Nous nous réservons le droit d\'enquêter sur les violations et de prendre les mesures appropriées, y compris la résiliation du compte et le signalement aux autorités si nécessaire.',
    },
    intellectual: {
      title: '6. Droits de Propriété Intellectuelle',
      ownership: {
        title: '6.1 Notre Contenu',
        p1: 'Tout le contenu du jeu, y compris mais sans s\'y limiter les mécaniques de jeu, les illustrations, les animations, les effets sonores, le code et le design, appartient à Animal Chess Limited ou à nos concédants de licence.',
        p2: 'Vous recevez une licence limitée, non exclusive et non transférable pour utiliser le Service uniquement à des fins de divertissement personnel.',
      },
      userContent: {
        title: '6.2 Contenu Utilisateur',
        p1: 'En soumettant du contenu (comme des messages de chat, des noms d\'utilisateur ou des informations de profil), vous nous accordez une licence mondiale et libre de droits pour utiliser, afficher et distribuer ce contenu en relation avec le Service.',
        p2: 'Vous déclarez être propriétaire ou avoir les droits nécessaires sur tout contenu que vous soumettez.',
      },
    },
    disclaimers: {
      title: '7. Avertissements et Limitations de Responsabilité',
      p1: 'LE SERVICE EST FOURNI « EN L\'ÉTAT » SANS GARANTIE D\'AUCUNE SORTE, EXPRESSE OU IMPLICITE.',
      p2: 'Nous ne garantissons pas que :',
      item1: 'Le Service sera ininterrompu ou sans erreur',
      item2: 'Les défauts seront corrigés',
      item3: 'Le Service est exempt de virus ou de composants nuisibles',
      item4: 'Les résultats de l\'utilisation du Service répondront à vos attentes',
      p3: 'DANS LA MESURE MAXIMALE PERMISE PAR LA LOI, NOUS NE SOMMES PAS RESPONSABLES DE :',
      item5: 'Tout dommage indirect, accessoire ou consécutif',
      item6: 'Perte de profits, de données ou de clientèle',
      item7: 'Interruptions de service ou perte de données',
      item8: 'Dommages dépassant le montant que vous nous avez payé au cours des 12 derniers mois',
    },
    privacy: {
      title: '8. Confidentialité',
      p1: 'Votre utilisation du Service est également régie par notre Politique de Confidentialité, qui explique comment nous collectons, utilisons et protégeons vos informations personnelles.',
      p2: 'En utilisant le Service, vous consentez à nos pratiques de données telles que décrites dans la Politique de Confidentialité.',
    },
    changes: {
      title: '9. Modifications des Conditions',
      p1: 'Nous nous réservons le droit de modifier ces Conditions d\'Utilisation à tout moment. Nous informerons les utilisateurs des modifications importantes via :',
      item1: 'Notification par e-mail aux utilisateurs inscrits',
      item2: 'Avis visible sur le site web',
      item3: 'Date « Dernière mise à jour » actualisée en haut de cette page',
      p2: 'Votre utilisation continue du Service après les modifications constitue l\'acceptation des conditions modifiées.',
    },
    governing: {
      title: '10. Loi Applicable',
      p1: 'Ces Conditions d\'Utilisation sont régies par les lois de la Nouvelle-Zélande, sans égard aux principes de conflit de lois.',
      p2: 'Tout litige découlant de ces conditions ou de votre utilisation du Service sera résolu devant les tribunaux de Nouvelle-Zélande.',
    },
    contact: {
      title: '11. Coordonnées',
      p1: 'Pour toute question, préoccupation ou assistance concernant ces Conditions d\'Utilisation :',
      email: 'E-mail :',
      company: 'Société :',
      address: 'Adresse :',
    },
    severability: {
      title: '12. Divisibilité',
      p1: 'Si une disposition de ces conditions est jugée inapplicable ou invalide, cette disposition sera limitée ou éliminée dans la mesure minimale nécessaire, et les autres dispositions resteront pleinement en vigueur.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Politique de Cookies',
    lastUpdated: 'Dernière mise à jour',
    browserInstructions: {
      chrome: 'Chrome : Paramètres → Confidentialité et sécurité → Cookies',
      firefox: 'Firefox : Paramètres → Vie privée et sécurité → Cookies et données de sites',
      safari: 'Safari : Préférences → Confidentialité → Cookies et données de sites web',
      edge: 'Edge : Paramètres → Confidentialité, recherche et services → Cookies',
    },
    cookieTable: {
      name: 'Nom du cookie',
      purpose: 'Objectif',
      duration: 'Durée',
      type: 'Type',
    },
    relatedPolicies: {
      title: 'Politiques Connexes',
      description: 'Pour plus d\'informations sur la façon dont nous gérons vos données, veuillez consulter :',
      privacy: 'Politique de Confidentialité',
      terms: 'Conditions d\'Utilisation',
    },
    introduction: {
      title: 'Introduction',
      p1: 'Cette Politique de Cookies explique comment Zodiac Chess ("nous," "notre") utilise les cookies et technologies similaires lorsque vous visitez notre site web.',
      p2: 'En utilisant notre site web, vous consentez à notre utilisation des cookies conformément à cette politique. Si vous n\'êtes pas d\'accord, veuillez désactiver les cookies dans les paramètres de votre navigateur ou ne pas utiliser notre site web.',
    },
    what: {
      title: 'Que sont les Cookies ?',
      p1: 'Les cookies sont de petits fichiers texte qui sont placés sur votre appareil (ordinateur, smartphone, tablette) lorsque vous visitez un site web. Ils sont largement utilisés pour faire fonctionner les sites web efficacement et fournir des informations aux propriétaires de sites.',
      p2: 'Les cookies servent à diverses fins, notamment mémoriser vos préférences, analyser l\'utilisation du site et activer certaines fonctionnalités.',
    },
    types: {
      title: 'Types de Cookies que Nous Utilisons',
      necessary: {
        title: '1. Cookies Nécessaires',
        description: 'Ces cookies sont essentiels au bon fonctionnement du site web. Sans ces cookies, les services que vous avez demandés ne peuvent pas être fournis.',
        examples: 'Exemples :',
        item1: 'Cookies d\'authentification - Vous maintiennent connecté à votre compte',
        item2: 'Cookies de sécurité - Protègent contre les activités frauduleuses',
        item3: 'Cookies de session - Maintiennent l\'état de votre jeu pendant une session',
        item4: 'Préférences de consentement aux cookies - Mémorisent vos choix de cookies',
      },
      analytics: {
        title: '2. Cookies Analytiques',
        description: 'Ces cookies nous aident à comprendre comment les visiteurs interagissent avec notre site web en collectant des informations anonymes sur les visites de pages, le temps passé et les fonctionnalités utilisées.',
        provider: 'Fournisseur : Firebase Analytics (Google)',
        purpose: 'Objectif :',
        item1: 'Mesurer le trafic du site web et l\'engagement des utilisateurs',
        item2: 'Identifier les fonctionnalités et pages populaires',
        item3: 'Comprendre la démographie des utilisateurs (tranche d\'âge, localisation générale)',
        item4: 'Améliorer les performances du site web et l\'expérience utilisateur',
      },
      advertising: {
        title: '3. Cookies Publicitaires',
        description: 'Ces cookies sont utilisés pour afficher des publicités qui vous sont pertinentes. Ils limitent également le nombre de fois que vous voyez une publicité et aident à mesurer l\'efficacité des campagnes publicitaires.',
        provider: 'Fournisseur : Google AdSense',
        purpose: 'Objectif :',
        item1: 'Afficher des publicités personnalisées basées sur vos intérêts',
        item2: 'Mesurer la performance des publicités et l\'engagement',
        item3: 'Empêcher l\'affichage de la même publicité trop souvent',
        note: 'Note : Les abonnés premium ne voient jamais de publicités, quels que soient les paramètres de cookies.',
      },
    },
    firstThird: {
      title: 'Cookies Internes vs Cookies Tiers',
      firstParty: {
        title: 'Cookies Internes',
        description: 'Ce sont des cookies définis directement par Zodiac Chess. Nous les utilisons pour les fonctionnalités essentielles du site, l\'authentification et la mémorisation de vos préférences.',
      },
      thirdParty: {
        title: 'Cookies Tiers',
        description: 'Ce sont des cookies définis par des services externes que nous utilisons, tels que Google Analytics et Google AdSense. Les cookies tiers sont soumis aux politiques de confidentialité de ces fournisseurs.',
      },
    },
    specific: {
      title: 'Cookies Spécifiques que Nous Utilisons',
      tableHeader: 'Voici une liste détaillée des cookies utilisés sur notre site web :',
    },
    control: {
      title: 'Comment Contrôler les Cookies',
      consent: {
        title: '1. Bannière de Consentement aux Cookies',
        description: 'Lors de votre première visite sur notre site web, vous verrez une bannière de consentement aux cookies. Vous pouvez :',
        item1: 'Tout accepter - Autoriser tous les cookies (nécessaires, analytiques et publicitaires)',
        item2: 'Refuser les optionnels - Autoriser uniquement les cookies nécessaires (pas d\'analytique ni de publicités)',
        item3: 'Personnaliser - Choisir exactement quels types de cookies vous souhaitez autoriser',
      },
      browser: {
        title: '2. Paramètres du Navigateur',
        description: 'La plupart des navigateurs web vous permettent de contrôler les cookies via leurs paramètres. Vous pouvez :',
        item1: 'Bloquer tous les cookies',
        item2: 'Accepter uniquement les cookies internes',
        item3: 'Supprimer les cookies après chaque session de navigation',
        item4: 'Afficher et supprimer les cookies individuels',
        links: 'Voici des liens vers la gestion des cookies pour les navigateurs populaires :',
      },
      optOut: {
        title: '3. Outils de Désinscription',
        description: 'Pour les cookies publicitaires spécifiquement, vous pouvez vous désinscrire des publicités personnalisées :',
        googleLink: 'Paramètres des publicités Google',
        googleDesc: ' - Gérer les publicités personnalisées Google',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - Se désinscrire de la publicité basée sur les intérêts',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - Outil de désinscription spécifique à l\'UE',
      },
    },
    impact: {
      title: 'Impact de la Désactivation des Cookies',
      p1: 'Si vous désactivez ou refusez les cookies, veuillez noter que :',
      item1: 'Certaines parties du site web peuvent ne pas fonctionner correctement',
      item2: 'Vous devrez peut-être ressaisir vos préférences à chaque visite',
      item3: 'Vous pourriez être déconnecté de votre compte',
      item4: 'Les cookies nécessaires sont requis pour que le site fonctionne - les désactiver vous empêchera d\'utiliser les fonctionnalités principales',
    },
    updates: {
      title: 'Mises à Jour de Cette Politique de Cookies',
      p1: 'Nous pouvons mettre à jour cette Politique de Cookies de temps en temps pour refléter les changements dans nos pratiques ou pour des raisons légales, réglementaires ou opérationnelles.',
      p2: 'Nous vous informerons des changements importants en mettant à jour la date de "Dernière mise à jour" en haut de cette page. Veuillez consulter cette politique périodiquement.',
    },
    contact: {
      title: 'Nous Contacter',
      p1: 'Si vous avez des questions sur notre utilisation des cookies ou cette Politique de Cookies, veuillez nous contacter :',
      email: 'E-mail :',
      company: 'Entreprise :',
    },
  },

  // Game
  game: {
    yourTurn: 'Votre Tour',
    opponentTurn: 'Tour de l\'Adversaire',
    victory: 'Victoire !',
    defeat: 'Défaite',
    draw: 'Match Nul',
    resign: 'Abandonner',
    offerDraw: 'Proposer Nul',
  },

  // Game End
  gameEnd: {
    victory: 'VICTOIRE !',
    defeat: 'DÉFAITE !',
    draw: 'MATCH NUL !',
    wonBy: 'Gagné par {condition}',
    lostBy: 'Perdu par {condition}',
    drawBy: 'Match nul par {condition}',
    youCapturedTheirKing: 'You captured their {piece} King!',
    yourKingWasCaptured: 'Your {piece} King was captured!',
    rematchButton: 'Rematch',
    backButton: 'Back',
    conditions: {
      kingslayer: 'Régicide',
      race: 'Victoire de Course',
      timeout: 'Temps Écoulé',
      threefold: 'Répétition 3x',
      noMoves: 'Aucun Mouvement Valide',
      draw: 'Match Nul',
    },
  },

  // Game Info
  gameInfo: {
    title: 'Infos de Partie',
    sandboxMode: 'Mode Bac à Sable',
    lightTurn: 'Tour des Clairs',
    darkTurn: 'Tour des Sombres',
    yourTurn: 'Votre tour',
    opponentTurn: 'Tour de l\'adversaire',
    aiThinking: 'L\'IA réfléchit...',

    // Selection states
    selecting: 'Sélection de {piece}',
    observing: 'Observation de {piece}',
    selectingZombified: 'Sélection de l\'ennemi zombifié {piece}',
    selectionLocked: 'Sélection verrouillée sur {piece}',
    selectionLockedPenguin: 'Le Pingouin est verrouillé',

    // Hints
    clickToFaint: 'Cliquez sur {piece} pour évanouir',
    clickToRotate: 'Cliquez sur {piece} pour pivoter',
    clickToInk: 'Cliquez sur {piece} pour encrer',
    zombifiedWarning: '⚠️ Zombifié, {piece} pivote avant de bouger !',

    // Monkey bonus turn
    monkeySwing: 'Le Singe a terminé sa balançoire, déplacez votre Singe pour compléter le tour bonus',
    monkeyConsume: 'Le Singe a consommé le champignon, déplacez votre Singe pour compléter le tour bonus',

    // Virus bonus turn
    virusInfecting: 'Le Virus infecte, continuez le tour ou cliquez sur le virus pour terminer',

    // Penguin bonus turn
    penguinRotate: 'Le Pingouin a terminé sa glissade - choisissez la direction de rotation finale',
    penguinCaptureRotate: 'Le Pingouin a terminé sa capture - choisissez la direction de rotation finale',
    penguinZombified: 'Le Pingouin zombifié a pivoté - complétez le tour avec glissade/capture (la zombification prendra fin)',

    // Capture restrictions
    cannotCapture: '{piece} ne peut pas capturer : {targets}',
    cannotInfect: '{piece} ne peut pas infecter : {targets}',
    cannotEntangle: '{piece} ne peut pas enchevêtrer : {targets}',
    monkeyBearRoll: '{piece} doit obtenir 5-6 pour capturer l\'ennemi {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',

    // Meadow warning (Tree immobilization)
    meadowWarning: '{piece} is immobilized by enemy {fungi}',
    rhinoChargeWarning: '{piece} charge does not affect: {targets}',
    snakeStrikeWarning: '{piece} strike does not affect: {targets}',
  },

  // Piece names
  pieces: {
    Bear: 'Ours',
    Crane: 'Grue',
    Frog: 'Grenouille',
    Fungi: 'Champignon',
    Goat: 'Chèvre',
    Monkey: 'Singe',
    Octopus: 'Pieuvre',
    Penguin: 'Pingouin',
    Rhino: 'Rhinocéros',
    Snake: 'Serpent',
    Tree: 'Arbre',
    Virus: 'Virus',
    Wolf: 'Loup',
  },

  // Short poetic vibe descriptions for landing carousel — one per variant
  pieceVibes: {
    Bear:    { light: 'Few dare approach',                   dark: 'Nothing impedes her hunger' },
    Crane:   { light: 'Sailing above, quieter than the wind',      dark: 'It circles. It waits. The lonely never return home' },
    Frog:    { light: 'Lazing on the lily pad',       dark: 'Take the colors as a warning' },
    Fungi:   { light: 'The meadow-maker',         dark: 'Consume and see who has been consumed' },
    Goat:    { light: 'Catch me on the cliff side',   dark: 'The corpse that blinks' },
    Monkey:  { light: 'Branch to branch to foe, laughing all the way',               dark: 'Roll the bones. Smiles either way' },
    Octopus: { light: 'Soft arms, razor sharp hooks, never releasing its grip',  dark: 'A bloom of black water. The shape inside is gone' },
    Penguin: { light: 'A harmless little thing in a tiny black coat',        dark: 'Slow and cute, right?' },
    Rhino:   { light: 'Waiting to face down a challenger', dark: 'Lock eyes at your peril' },
    Snake:   { light: 'Changing endings like outfits',                               dark: 'Do not tread near me' },
    Tree:    { light: 'A haven amongst the beasts',             dark: 'Standing where the dead stood. Still standing' },
    Virus:   { light: 'The battle for pandoras box',         dark: 'They feel triumph, then a cough, then silent disbelief' },
    Wolf:    { light: 'The alpha of his pack',  dark: 'When the pack is gone. What remains excites' },
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Contexte de Mouvement',
    emptyState: 'Sélectionnez une capacité dans le panneau de gauche pour voir les informations détaillées.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'ARÈNE IA',
    tagline: 'Choisissez une IA à combattre ou regardez les IA s\'affronter !',

    // Player labels
    lightPlayer: 'Joueur Clair',
    darkPlayer: 'Joueur Sombre',
    humanPlayer: 'Joueur Humain',
    aiPlayer: 'AI',
    difficulty: 'Difficulty',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinelle',
    aiAlchemist: 'Alchimiste',
    aiZenith: 'Zénith',
    aiTrapper: 'Trappeur',
    aiHunter: 'Chasseur',
    aiWisp: 'Feu Follet',
    aiCreature: 'Creature',
    aiWeaver: 'Tisseur',

    // Time Frames
    timeFast: 'Rapide',
    timeStandard: 'Standard',
    timeDeep: 'Profond',

    // Thinking time
    thinkingTime: 'Temps de Réflexion',

    // Info box
    matchupLabel: 'Confrontation :',
    statusLabel: 'Statut :',
    statusPaused: 'EN PAUSE',
    statusAIThinking: 'IA en réflexion...',
    statusInGame: 'En Partie',
    statusReady: 'Prêt',
    matchupLocal2P: '2J Local',
    matchupPlayerVs: 'Joueur vs',
    matchupVsPlayer: 'vs Joueur',

    // Buttons
    startButton: 'Démarrer',
    startRandomButton: 'Démarrer Aléatoire',
    newGameButton: 'Nouvelle Partie',
    resumeButton: 'Reprendre',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (en attente...)',
    viewKingsButton: 'Voir les Rois',
    hideKingsButton: 'Cacher les Rois',
    viewKingsQueuedButton: 'Voir les Rois (en attente...)',
    hideKingsQueuedButton: 'Cacher les Rois (en attente...)',
    homeButton: 'Accueil',
    toggleKingVisibility: 'Basculer la visibilité des rois',

    // Warning modal
    invalidPlacement: 'Placement Invalide',
    okButton: 'OK',
    warningLightTurn: 'C\'est au joueur Clair de placer une pièce !',
    warningDarkTurn: 'C\'est au joueur Sombre de placer une pièce !',
    warningLightRow: 'Les pièces claires doivent être placées sur la rangée 0 (votre rangée de départ) !',
    warningDarkRow: 'Les pièces sombres doivent être placées sur la rangée 7 (votre rangée de départ) !',
    warningOccupied: 'Cette case est déjà occupée ! Choisissez une case vide.',
    warningKingRequired: 'Vous devez placer votre roi ({kingType}) avant de placer votre 5ème pièce !',

    // Piece selection
    dragPieces: 'Glissez les pièces sur le plateau',
    lightPieces: 'Pièces Claires',
    darkPieces: 'Pièces Sombres',

    // Mobile
    selectYourKing: 'Sélectionnez Votre Roi',
    selectPieceToPlace: 'Sélectionnez une Pièce à Placer',
    moveHistory: 'Historique des Coups',
    historyButton: 'Historique',
    backButton: 'Retour',
    lightTurn: 'Tour des Clairs',
    darkTurn: 'Tour des Sombres',
  },

  // Upgrade Modal
  upgrade: {
    title: 'Passer à Premium',
    accountRequired: 'Vous devez créer un compte permanent avant de passer à premium.',
    createAccountPrompt: 'Créez un compte pour sauvegarder votre progression et débloquer les fonctionnalités premium !',
    subtitle: 'Débloquez des fonctionnalités puissantes pour améliorer votre expérience Zodiac Chess !',
    features: {
      history: 'Historique du Compte',
      historyItem1: 'Stockez et rappelez toutes vos parties précédentes',
      historyItem2: 'Rejouez vos anciennes parties depuis n\'importe quel point pour évaluer la stratégie',
      historyItem3: 'Utilisez des analyses approfondies pour analyser les positions et les opportunités de coups brillants',
      analytics: 'Analytiques',
      analyticsItem1: 'Accédez aux statistiques de jeu',
      analyticsItem2: 'Analysez les sélections de pièces et de rois des utilisateurs à travers de nombreuses métriques',
      analyticsItem3: 'Découvrez quelles métas sont populaires et ce qui fonctionne !',
      course: 'Cours',
      courseItem1: 'Accédez à des cours à jour pour développer vos compétences',
      courseItem2: 'Apprenez les métas et concepts des pros',
      courseItem3: 'Obtenez des conseils sur votre propre jeu pour analyser vos faiblesses',
    },
    createAccount: 'Créer un Compte',
    upgradeNow: 'Passer à Premium',
    cancel: 'Annuler',
  },

  // Premium Modal
  premium: {
    title: 'Fonctionnalité Premium',
    accessDenied: 'Désolé, vous n\'avez pas de compte premium, vous n\'avez pas encore accès à ces fonctionnalités !',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oups ! Quelque chose s\'est mal passé',
    errorMessage: 'Nous avons rencontré un problème lors du traitement de votre paiement. Ne vous inquiétez pas, vous n\'avez pas été débité.',
    whatHappened: 'Que s\'est-il passé ?',
    notCompleted: 'Votre paiement n\'a pas été effectué. Cela peut être dû à :',
    reasons: {
      cancelled: 'Paiement annulé',
      declined: 'Carte refusée',
      connection: 'Problème de connexion lors du paiement',
      expired: 'Session expirée',
    },
    whatToDo: 'Que pouvez-vous faire ?',
    actions: {
      tryDifferentCard: 'Essayez avec une autre carte',
      tryDifferentCardDesc: 'Utilisez un autre moyen de paiement',
      retryPayment: 'Réessayez le paiement',
      retryPaymentDesc: 'Parfois, un simple nouvel essai fonctionne',
      checkBank: 'Vérifiez avec votre banque',
      checkBankDesc: 'Assurez-vous que votre carte a des fonds suffisants',
    },
    tryAgain: 'Réessayer de Passer à Premium',
    returnHome: 'Retour à la Page Principale',
    contactSupport: 'Besoin d\'aide ? Contactez le support à support@zodiac-chess.com',
  },

  // Donation
  donation: {
    title: 'Soutenez Zodiac Chess',
    supportDevelopment: 'Soutenir le Développement',
    story1: 'Bonjour ! Votre soutien m\'aide à continuer d\'améliorer ce jeu unique ! Ajouter de nouvelles fonctionnalités, maintenir les serveurs et garder Zodiac Chess gratuit pour la communauté.',
    story2: 'Même un petit don fait une énorme différence et maintient ce projet en vie. Merci de faire partie de l\'aventure Zodiac Chess :)',
    selectAmount: 'Choisir le Montant',
    customAmount: 'Ou entrez un montant personnalisé :',
    total: 'Total :',
    donateButton: 'Faire un Don',
    processing: 'Traitement...',
    disclaimer: 'Les dons soutiennent le développement et les coûts de serveur. Merci pour votre générosité !',
    invalidAmount: 'Veuillez entrer un montant valide supérieur à 0€',
    error: 'Une erreur s\'est produite lors du traitement de votre don. Veuillez réessayer.',
  },
  howToPlay: {
    whatIsZodiac: 'De quoi s\'agit-il ?',
    gameSetup: 'Configuration du Jeu',
    basicRules: 'Règles de Base',
    backButton: 'RETOUR',
    homeButton: 'Accueil',
    fullRules: 'Règles Complètes',
    whatIs: {
      p1: 'Zodiac Chess est une variante d\'échecs avec 13 pièces animales uniques au lieu des pièces traditionnelles.',
      p2: 'Chaque animal a des capacités spéciales et des mouvements qui créent des possibilités stratégiques complexes.',
      p3: 'Le jeu se joue sur un plateau 5x8 avec deux équipes : Claire et Sombre.',
      p4: 'Chaque équipe commence avec 5 pièces arrangées sur leur première rangée.',
      p5: 'Le but est de capturer le roi adverse ou de courir votre roi jusqu\'au bord opposé.',
      p6: 'Maîtrisez chaque pièce pour devenir un maître de Zodiac Chess !',
    },
    setup: {
      p1: 'Le plateau mesure 5 colonnes de large et 8 rangées de haut.',
      p2: 'Les pièces claires commencent en bas, les pièces sombres en haut.',
      p3: 'Chaque équipe a exactement 5 pièces au départ.',
      p4: 'Une pièce de chaque équipe est désignée comme le Roi.',
      p5: 'La pièce roi peut être n\'importe quel animal (sauf le Virus).',
      p6: 'Le jeu propose des départs aléatoires avec des compositions de pièces variées.',
    },
    rules: {
      intro: 'Règles de base pour le gameplay :',
      toWinTitle: 'Pour Gagner :',
      toWin1: 'Capturez le roi adverse',
      toWin2: 'Amenez votre roi au bord opposé du plateau',
      toWin3: 'Si votre roi et le roi adverse sont tous deux capturés dans le même tour, le capteur gagne',
      toWin4: 'Les matchs se terminent immédiatement quand une condition de victoire est atteinte',
      drawTitle: 'Match Nul :',
      draw1: 'Les matchs nuls surviennent par répétition triple ou impasse',
      draw2: 'Les joueurs peuvent aussi s\'accorder sur un match nul',
    },
    tutorials: {
      bear: {
        desc1: 'Mouvement régulier - L\'Ours peut se déplacer d\'une case dans n\'importe quelle direction',
        desc2: 'La capacité "Sauvage" de l\'Ours lui permet de capturer n\'importe quelle pièce peu importe les capacités défensives',
        desc3: 'L\'ours est une pièce "grande" et "prédateur" ce qui signifie que beaucoup d\'autres Zodiaques ne peuvent pas le capturer !',
      },
      crane: {
        desc1: 'La Grue peut se déplacer de 1 ou 2 cases en ligne droite pour son mouvement régulier',
        desc2: 'La Grue ne peut capturer aucune pièce "grande" ou "prédateur"',
      },
      frog: {
        desc1: 'La grenouille peut sauter de 2 cases en diagonale pour son mouvement régulier, même par-dessus d\'autres pièces !',
        desc2: 'Si le mouvement régulier de la grenouille est bloqué par un mur ou une pièce qu\'elle ne peut pas capturer, son mouvement régulier est réduit à 1 case en diagonale',
        desc3: 'Si la grenouille n\'a pas encore bougé dans la partie, elle est sur son "nénuphar" et peut se déplacer vers n\'importe laquelle des 3 premières rangées comme mouvement défensif',
        desc4: 'Si une pièce capture une grenouille, elle devient empoisonnée et ne peut faire aucun mouvement pour son prochain tour disponible',
        desc5: 'Le mouvement spécial de la grenouille est "escalade de mur" - si une grenouille est à côté du bord du plateau, elle peut aussi se déplacer d\'une case vers le haut ou le bas',
      },
      fungi: {
        desc1: 'Le Champignon peut se déplacer d\'une case dans n\'importe quelle direction pour son mouvement régulier',
        desc2: 'La capacité "prairie" du champignon empêche un arbre de se déplacer s\'il est à une case du champignon et ne permet pas à un arbre de se déplacer à une case du champignon ennemi',
        desc3: 'Quand il est capturé, le champignon applique un effet "zombie" à toute pièce animale qui l\'a capturé',
        desc4: 'Pendant la zombification, le champignon contrôle la pièce pour le tour suivant et agit comme la pièce, ce qui signifie que si le champignon était votre roi, vous pouvez toujours gagner par victoire de course ou en capturant le roi ennemi dans ce tour',
      },
      goat: {
        desc1: 'La chèvre peut se déplacer d\'une case dans n\'importe quelle direction pour son mouvement régulier',
        desc2: 'La capacité "traversée" de la chèvre lui permet de sauter par-dessus des pièces liées puis de se déplacer, elle ne peut capturer aucune pièce lors d\'une traversée',
        desc3: 'La chèvre ne peut capturer aucun "prédateur"',
        desc4: 'La chèvre peut utiliser une capacité spéciale appelée "évanouissement" pour se faire passer pour morte',
        desc5: 'Pendant l\'évanouissement, la chèvre ne peut pas être capturée par la plupart des pièces mais ne peut pas se déplacer si une autre pièce est "debout" dessus (sur la même case)',
      },
      monkey: {
        desc1: 'Le singe peut se déplacer d\'une case dans n\'importe quelle direction pour son mouvement régulier',
        desc2: 'Le singe peut "bondir" par-dessus des pièces amies et ennemies comme une pièce de dames si la formation le permet',
        desc3: 'Si le singe bondit par-dessus une pièce ennemie, il doit lancer un dé pour ne pas être capturé ! Un point de danger par pièce ennemie qu\'il saute en une seule ligne',
        desc4: 'Le singe PEUT capturer un ours s\'il décide de jouer pour l\'attaquer, sur un jet de 1-4 avec un dé à six faces, le Singe est capturé, sur un 5 ou 6, le Singe capture l\'ours',
        desc5: 'Le singe a deux capacités - "balancement" et "consommer" lors d\'un balancement (un bond finissant sur un arbre), le singe gagne un mouvement supplémentaire, lors de la consommation d\'un champignon, le singe gagne aussi un mouvement supplémentaire avant la fin de son tour',
      },
      octopus: {
        desc1: 'La pieuvre peut se déplacer d\'une case dans n\'importe quelle direction pour son mouvement régulier',
        desc2: 'La pieuvre ne peut capturer que sur les cases orthogonales',
        desc3: 'La pieuvre peut utiliser sa capacité "enchevêtrement" sur toute pièce animale sur les cases diagonales',
        desc4: 'La pieuvre peut faire n\'importe quel mouvement ET enchevêtrer en un seul tour',
        desc5: 'La pieuvre a une capacité appelée "encre" avec cette capacité elle peut se déplacer vers n\'importe quelle case orthogonale et placer des "ombres" sur les 3 autres cases orthogonales si elles ne sont pas occupées ou hors du plateau. Pour l\'adversaire, pendant le tour suivant la capacité "encre", les ombres et la vraie pieuvre sont indiscernables',
      },
      penguin: {
        desc1: 'Le pingouin a une capacité appelée "rotation" c\'est la seule pièce qui a une direction définie et peut utiliser le mouvement "rotation" pour rediriger sa direction pour son tour',
        desc2: 'Pour le mouvement régulier "glissade" du pingouin, il doit se déplacer jusqu\'au point le plus éloigné dans la direction qu\'il fait face et une fois là, il peut utiliser une rotation avant la fin de son tour pour rediriger sa direction',
        desc3: 'Le pingouin ne peut capturer aucune pièce "grande" ou "prédateur". Il peut capturer toute autre pièce à une case de lui et utiliser une capacité de rotation après la capture',
      },
      rhino: {
        desc1: 'Le rhinocéros peut se déplacer "arrière gauche", "arrière droite" ou deux en avant dans le cadre de son mouvement régulier',
        desc2: 'Le rhinocéros a une capacité appelée "piétinement" où il capture TOUTES les pièces sur le chemin de son mouvement',
        desc3: 'Une fois par partie, un rhinocéros peut effectuer une charge de 3 cases devant si un animal est présent dans l\'une des 3 cases directement devant le rhinocéros',
        desc4: 'Le rhinocéros a une capacité spéciale appelée "défense rhinocéros" où le rhinocéros ne peut pas être capturé par "l\'avant"',
        desc5: 'Le rhinocéros a une capacité appelée "voie" où s\'il n\'a pas bougé et que la pièce amie directement à sa gauche ou à sa droite n\'a pas bougé, il peut échanger de place avec cette pièce pour son tour',
      },
      snake: {
        desc1: 'Le serpent peut se déplacer de 2 cases uniquement dans les directions orthogonales, y compris à travers d\'autres pièces pour son mouvement régulier',
        desc2: 'Si son mouvement régulier est bloqué par un mur ou une pièce qu\'il ne peut pas capturer, son mouvement régulier devient 1',
        desc3: 'Le serpent a une capacité appelée "frappe" où si un animal est exactement à 3 cases devant lui et qu\'il n\'y a pas de pièces entre les deux, il peut "frapper" en avant et capturer cet animal',
        desc4: 'Le serpent a une capacité appelée "mue" où une fois par partie si le serpent est capturé, il reviendra à la première rangée du plateau, dans la même colonne, comme s\'il avait une seconde vie. Si la première rangée n\'est pas une case valide pour le serpent, il est définitivement capturé',
      },
      tree: {
        desc1: 'L\'arbre peut se déplacer d\'une case en avant ou de façon illimitée d\'un côté à l\'autre s\'il n\'est pas bloqué par une autre pièce',
        desc2: 'L\'arbre a une capacité spéciale appelée "maison" où toute pièce qui peut "grimper" aux arbres peut s\'asseoir au-dessus de la pièce arbre. Si une pièce ennemie attaque un arbre avec une pièce hébergée, la pièce hébergée est capturée et l\'arbre héberge la pièce ennemie',
        desc3: 'Quand une pièce est hébergée dans l\'arbre, si une pièce ennemie ne peut pas grimper à l\'arbre, l\'arbre et la pièce hébergée sont tous deux protégés de la capture',
      },
      wolf: {
        desc1: 'Le loup se déplace en forme de L comme un cavalier aux échecs pour son mouvement régulier',
        desc2: 'Si le loup est la dernière pièce sur le plateau*, sa capacité "loup solitaire" est activée et il se déplace en un long L à la place comme illustré ci-dessus. *Le loup entrera en mode solitaire s\'il est en équipe avec une chèvre évanouie ou un virus infectant',
      },
      virus: {
        desc1: 'Le virus peut se déplacer de 2 cases dans n\'importe quelle ligne droite pour son mouvement régulier, il ne capture pas mais utilise sa capacité "infecter" pour que la pièce soit infectée plutôt que capturée',
        desc2: 'Le virus ne peut se déplacer que vers n\'importe quelle pièce animale, s\'il est bloqué par un mur, le mouvement régulier du virus est seulement de 1 case',
        desc3: 'Quand une pièce animale est "infectée", si le virus quitte la pièce infectée vers une autre pièce, la pièce qu\'il a quittée est capturée et la nouvelle pièce est "infectée"',
        desc4: 'Le virus a une capacité appelée "contagieux" qui permet au virus de compléter autant de mouvements valides en un seul mouvement qu\'il le souhaite, capturant plusieurs animaux en un tour',
        desc5: 'Quand le virus n\'est pas en train d\'"infecter", il peut être capturé comme n\'importe quelle autre pièce. Si un animal capture une pièce infectée, il devient infecté',
      },
    },
  },
};

